import { createThunk, ListModel, model, view } from 'mst-collection';
import { getRoot, types } from 'mobx-state-tree';
import Fuse from 'fuse.js';

import { QuestTopicModel, QuestTopic } from './QuestTopicModel';
import { Api, schemas } from '@api';
import type { RootModelType } from '../RootModel';

export class QuestTopicList extends ListModel(
  types.reference(QuestTopicModel),
  {
    idAttribute: 'id',
    schema: schemas.QuestTopicListSchema,
  },
) {
  private _fuse: Fuse<QuestTopic> | null = null;

  private _setFuse() {
    this._fuse = new Fuse<QuestTopic>(this.array, { keys: ['name'] });
  }

  get selectedTopicIds() {
    return this.array.filter((t) => t.isSelected).map((t) => t.id);
  }

  get canSelectTopic() {
    return this.selectedTopicIds.length < 5;
  }

  @view
  searchByText(value: string) {
    return this._fuse?.search(value).map((r) => r.item) ?? this.array;
  }

  private _selectTopicsByIds(ids: number[]) {
    this.array.forEach((i) => {
      if (!i.isSelected && ids.includes(i.id)) {
        i.toggleSelect();
      }
    });
  }

  fetch = createThunk(() => {
    return async function fetch(this: QuestTopicList) {
      const res = await Api.Profile.getQuestTopics();

      this.set(res.data);
      this._setFuse();

      const isSkipped =
        getRoot<RootModelType>(this).viewer.currentUser?.settings
          .isSkippedQuest;

      // During skipping we are save progress of quest
      // And here we fetch the progress that was made by user
      // before skipping quest last time
      if (isSkipped) {
        const selectedTopicRes =
          await Api.Profile.getSelectedQuestTopics();

        this._selectTopicsByIds(selectedTopicRes.data);
      }
    };
  });
}

export const QuestTopicListModel = model(QuestTopicList);
